import { useEffect, useState, useRef } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch } from "react-redux"
import { setAdditionalSubHdView, setSubHeading } from "../../store/reducers/CommonReducer"
import { setContentLoading } from "../../store/reducers/CommonReducer"
import TabExtraContent from '../common/TabExtraContent'
import UMCButton from '../common/UMCButton'
import { getHTMLObject, getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import { Divider, Select, Button } from 'antd'
import { DARK_GRAY, PURPLE, } from "../../styles/styleUtils"
import getData from './GetData'
import { CC_PRODUCT_ID } from "../../utils/Constants"
import { getSessionItem } from "../../utils/storageUtils"
import { SIP_URL } from "../../utils/Config"
import InputField from "./InputField"
import CustomDialog from './CustomDialog'
import parse from 'html-react-parser'

//====================================
// Dispatch Console third config page
//====================================
const DCGWARSPrefix = ({ onPrevious, onNext, activeProfile, trunkConfig, setTrunkConfig, configurationData, setConfigurationData }) => {
    const [errorsOnPage, setErrorsOnPage] = useState(0);
    const [errorsOnrange, setErrorsOnrange] = useState(false);
    const [range, setRange] = useState(""); // Range calculation display

    const [workingSipTrunkConfig, setWorkingSipTrunkConfig] = useImmer(trunkConfig);

    // Dialog parameters
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dlgType, setDlgType] = useState();
    const [title, setTitle] = useState();
    const [message, setMessage] = useState();
    const [footer, setFooter] = useState([]);

    const start = useRef();
    const number = useRef();
    const creationAllowed = useRef(false); // Used to check if ACD prefix value can be created
    const creationError = useRef(false); // Used to display the creation error cause 

    const dispatch = useDispatch();
    const dict = useSelector((state) => state.common.dict);
    const language = useSelector((state) => state.common.language);
    const oxeAndClientInfo = useSelector((state) => state.oxe.oxeAndClientInfo);
    var ccproductid = getSessionItem(CC_PRODUCT_ID);
    var nodeNumber = oxeAndClientInfo?.nodeNumber || "";

    let errorsOnRedraw = errorsOnPage;

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()));

        if (trunkConfig?.Profile !== undefined) {
            setWorkingSipTrunkConfig(trunkConfig);
        }
    }, []);

    useEffect(() => {
        dispatch(setAdditionalSubHdView(getExtraSubHeaderContent()))
    }, [language]);

    // Top right icons 
    const getExtraSubHeaderContent = () => {
        return <TabExtraContent
            contentItems={activeProfile.docRef ? ["document", "help"] : ["help"]}
            documentButtonText={activeProfile.docRef}
            handleDocument={() => {
                if (activeProfile.docUrl !== "")
                    window.open(`${activeProfile.docUrl}`, "_blank")
            }}
            handleHelpReq={() => {
                // code to handle help doc action
                let src = `/hol/oxe/oxe-${language}/dita/topics/umc_EN_DE_ES_FR/umc_easy-sip-trunk-creation.html`
                window.open(`${src}#Create-DC_ARS-Config`, "_blank")
            }}
        />
    }

    // Calculate the range from begin with number of digits
    const calculateRange = (begin, number) => {
        let obj = null, beginLength = 0;

        if (number > 30) {
            obj = "";
        }
        else
            if (begin && number) {
                beginLength = begin.length;
                if (number > beginLength) {
                    let first = begin + '0'.repeat(number - beginLength);
                    let last = begin + '9'.repeat(number - beginLength);
                    obj = "Range: " + first + " - " + last;
                }
                else {
                    if (parseInt(number, 10) === beginLength) { 
                        obj = "Value: " + begin;
                    }
                }
            }

        return obj;
    }

    // Edit fields handlers
    const updateCallNumberStart = (value) => {
        start.current = value;
        updateCallNumber(value);
        if (number.current && number.current.length > 0) {
            setRange(calculateRange(start.current, number.current));
        }
        else {
            setRange("");
        }
        if ((value !== "") && (value !== undefined) && (number.current !== "") && (number.current !== undefined)) {
            if ((value.length <= number.current)) {
                setErrorsOnrange(false);
            }
            else {
                setErrorsOnrange(true);
            }
        }
        else
            setErrorsOnrange(false);
    }

    const updateCallNumberLength = (value) => {
        number.current = value;
        updateNBDigits(value);
        if (start.current && start.current.length > 0) {
            setRange(calculateRange(start.current, number.current));
        }
        else {
            setRange("");
        }
        if ((value !== "") && (value !== undefined) && (start.current !== "") && (start.current !== undefined)) {
            if ((start.current.length <= value)) {
                setErrorsOnrange(false);
            }
            else {
                setErrorsOnrange(true);
            }
        }
        else {
            setErrorsOnrange(false);
        }
    }

    // Go back in the wizard, but save the values in case the user goes forward again
    const onBack = () => {
        // Update the parent state
        setTrunkConfig(workingSipTrunkConfig);

        // The go back
        onPrevious();
    }

    // DC Trunk data handlers
    const updateTrunkGroupName = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_DC_Ext_Gateway_Data.Trunk_Group_Name = value; });
    }

    const updateFQDN = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_DC_Ext_Gateway_Data.UMC_FQDN_Or_IP_Address = value; });
    }

    const updateARSPrefix = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_Prefix.UMC_ARS_Prefix.Local_Number = value; });
    }

    const updateCallNumber = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_Prefix.UMC_Calling_Number.Local_Number = value; });
    }

    const updateNBDigits = (value) => {
        setWorkingSipTrunkConfig(draft => { draft.Profile.UI_Prefix.UMC_Calling_Number.Number_Of_Digit = value; });
    }

    // Error handler (count errors on the page)
    const errorHandler = (value) => {

        if (value === true) {
            errorsOnRedraw++;
        }
        else {
            if (errorsOnPage > 0)
                errorsOnRedraw--;
        }
        setErrorsOnPage(errorsOnRedraw);
    }

    const creationHandler = (data) => {
        creationAllowed.current = data[0]?.creationPossible;
        creationError.current = data[0]?.errorCause;
    }

    // Check if ACD prefix can be created
    const checkARSPrefixCreation = async () => {
        var url, response;

        try {
            url = SIP_URL + "/check-ars-prefix-creation/" + nodeNumber + "/" + ccproductid + "/" + 
                workingSipTrunkConfig?.Profile?.UI_Prefix?.UMC_ARS_Prefix?.Local_Number;

            dispatch(setContentLoading(true));
            response = await getData(url, null, creationHandler);
            dispatch(setContentLoading(false));
        }
        catch (e) {
            console.error(e);
            dispatch(setContentLoading(false));
        }
    }

    // Check if duplicate in the buffer
    const checkDuplicate = () => {
        var number = workingSipTrunkConfig.Profile.UI_Prefix.UMC_ARS_Prefix.Local_Number;

        // Check value against ACD value
        if (workingSipTrunkConfig.Profile.UI_DispatchConsole_Prefix.ACD_Prefix.Local_Number  === number) {
            return true;
        }
        else {
            // Validate against RSI table
            const exists = workingSipTrunkConfig.Profile.UI_DispatchConsole_Prefix.RSI_Prefix.some(item => item.Local_Number === number)
            return exists;
        }
    }

    // Validation handler for the page
    async function validateFields() {

        if (!checkDuplicate()) {

            await checkARSPrefixCreation(); 

            if (creationAllowed.current === false) {
                setDlgType("Error");
                setTitle(getTranslated(dict, "LABEL_SIP_TRUNK_CREATION_IMPOSSIBLE"));   
                setMessage(parse(getTranslated(dict, "MSG_ARS_PREFIX_CANNOT_BE_CREATED") + (creationError.current ? "<br/>" + creationError.current : "")));
                setFooter(ok);
                showModal(true);
            }
        }
        else { 
            // Duplicate error in this config
            setDlgType("Error");
            setTitle(getTranslated(dict, "LABEL_SIP_TRUNK_CREATION_IMPOSSIBLE"));   
            setMessage(getTranslated(dict, "MSG_ALREADY_CHOOSEN"));
            setFooter(ok);
            showModal(true);
        }

        // Update the parent state
        setTrunkConfig(workingSipTrunkConfig);

        // Caution: this test (creationAllowed.current === true) can only be used if there is only one value 
        // creation check on the page, else it is needed to use a counter
        if ((errorsOnRedraw === 0) && (creationAllowed.current === true)) {
            onNext();
        }
    }

    // Modal message handlers
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    // Buttons for modal footer
    const ok = [
        <Button key="ok" type="primary" onClick={handleOk} className="sip-modal-btn">
            {getTranslated(dict, "LABEL_OK")}
        </Button>
    ];

    return (<>
        {(() => {
            if (configurationData?.Profile?.UI_DC_Ext_Gateway_Data !== undefined) {
                return (<>
                <div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_EXT_GATEWAY_DATA")}
                    </Divider>

                    { // Gateway name
                        configurationData?.Profile?.UI_DC_Ext_Gateway_Data?.Trunk_Group_Name &&
                        <InputField label={getTranslated(dict, "PARAM_TRUNK_GROUP_NAME")}
                            defaultValue={configurationData?.Profile?.UI_DC_Ext_Gateway_Data?.Trunk_Group_Name?.defaultValue}
                            regexp={configurationData?.Profile?.UI_DC_Ext_Gateway_Data?.Trunk_Group_Name?.pattern}
                            handleChange={updateTrunkGroupName}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_DC_Ext_Gateway_Data?.Trunk_Group_Name} />
                    }

                    { // FQDN or IP
                        configurationData.Profile?.UI_DC_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address &&
                        <InputField label={getTranslated(dict, "PARAM_DC_FQDN")}
                            defaultValue={configurationData.Profile?.UI_DC_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.defaultValue}
                            regexp={configurationData.Profile?.UI_DC_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address?.pattern}
                            handleChange={updateFQDN}
                            handleError={errorHandler}
                            validationPattern="Domain"
                            value={trunkConfig?.Profile?.UI_DC_Ext_Gateway_Data?.UMC_FQDN_Or_IP_Address} />
                    }
                </div>
                <div>
                    <Divider className="sip-header" orientation="left" orientationMargin="0" plain style={{ borderColor: DARK_GRAY, }}>
                        {getTranslated(dict, "LABEL_UI_DCPREFIX")}
                    </Divider>

                    { // ARS Prefix
                        configurationData?.Profile?.UI_Prefix?.UMC_ARS_Prefix?.Local_Number &&
                        <InputField label={getTranslated(dict, "PARAM_TRUNK_ARS_PREFIX")}
                            defaultValue={configurationData?.Profile?.UI_Prefix?.UMC_ARS_Prefix?.Local_Number?.defaultValue}
                            regexp={configurationData?.Profile?.UI_Prefix?.UMC_ARS_Prefix?.Local_Number?.pattern}
                            handleChange={updateARSPrefix}
                            handleError={errorHandler}
                            value={trunkConfig?.Profile?.UI_Prefix?.UMC_ARS_Prefix?.Local_Number} />
                    }

                    {   configurationData.Profile?.UI_Prefix?.UMC_Calling_Number?.Local_Number &&
                        configurationData.Profile?.UI_Prefix?.UMC_Calling_Number?.Number_Of_Digit &&
                        <div className={errorsOnrange ? "discrimination prefix-zone-error" : "discrimination prefix-zone"}>
                            <div className="prefix-title" >{getTranslated(dict, "PARAM_DISCRIMINATION_RULE")}</div>
                            <div className="prefix-fields">
                                <InputField label={getTranslated(dict, "PARAM_CALL_NUMBER")}
                                    defaultValue={configurationData.Profile?.UI_Prefix?.UMC_Calling_Number?.Local_Number?.defaultValue}
                                    regexp={configurationData.Profile?.UI_Prefix?.UMC_Calling_Number?.Local_Number?.pattern}
                                    handleChange={updateCallNumberStart}
                                    handleError={errorHandler}
                                    value={trunkConfig?.Profile?.UI_Prefix?.UMC_Calling_Number?.Local_Number} />
                                <InputField label={getTranslated(dict, "PARAM_PREFIX_NUMBER_DIGITS")}
                                    defaultValue={configurationData.Profile?.UI_Prefix?.UMC_Calling_Number?.Number_Of_Digit?.defaultValue}
                                    regexp={configurationData.Profile?.UI_Prefix?.UMC_Calling_Number?.Number_Of_Digit?.pattern}
                                    handleChange={updateCallNumberLength}
                                    handleError={errorHandler}
                                    validationPattern="[0-9]{0,2}"
                                    value={trunkConfig?.Profile?.UI_Prefix?.UMC_Calling_Number?.Number_Of_Digit} />
                            </div>
                            <div className="prefix-range" >{range}</div>
                        </div>
                    }
                </div>
                </>)
            }
        })()
        }

        <div className="sip-nav-buttons profile-span">
            <UMCButton
                className="sip-navigation-button sip-navigation-back sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_BACK")}
                type="primary"
                onClick={onBack}
                disabled={false} />
            <UMCButton
                className="sip-navigation-button sip-btn-fontsize"
                label={getTranslated(dict, "LABEL_CREATE")}
                type="primary"
                onClick={validateFields}
                disabled={(errorsOnPage !== 0) || errorsOnrange} />
        </div>
        <CustomDialog
            title={title}
            open={isModalOpen}
            width={dlgType === "Error" ? "400px" : "500px"}
            footer={footer}
            type={dlgType}
            onCancel={handleCancel}
        >
            {message}
        </CustomDialog>
    </>);
}

export default DCGWARSPrefix;